import React, { useState } from 'react';
import Footer from './Footer';

export default function Claimsupport() {
    const [fullname, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');
    const [product, setProduct] = useState('');
    const [policynumber, setPolicyNumber] = useState('');
    const [claimnumber, setClaimNumber] = useState('');
    const [claimamount, setClaimAmount] = useState('');
    const [incidentdetails, setIncidentDetails] = useState('');
    const [incidentdate, setIncidentDate] = useState('');
    const [documents, setDocuments] = useState([]); // State for file uploads
    const BASE_URL = 'https://node.insuranceadvisors.pk';


    // Handle file input change
    const handleFileChange = (e) => {
        setDocuments(e.target.files); // Store selected files
    };

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('fullname', fullname);
        formData.append('email', email);
        formData.append('contact', contact);
        formData.append('product', product);
        formData.append('policynumber', policynumber);
        formData.append('claimnumber', claimnumber);
        formData.append('claimamount', claimamount);
        formData.append('incidentdate', incidentdate);
        formData.append('incidentdetails', incidentdetails);

        // Append each file to formData
        Array.from(documents).forEach((file) => {
            formData.append('documents', file);
        });

        try {
            const response = await fetch(`${BASE_URL}/claim/saveclaim`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                alert('Claim submitted successfully');
                window.location.href = '/our';
            } else {
                console.error('Failed to submit data:', response.statusText);
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        }
    };

    return (
        <div className="claim-support-container" id="up">
            <div className="page-wrapper bg-dark p-t-100 p-b-50">
                <div className="wrapper wrapper--w900">
                    <div className="card card-6">
                        <div className="card-heading">
                            <h1 className="title">Claim Support</h1>
                            <p id='p_1'>Are you concerned about getting your claims settled? Contact us!</p>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                {/* Full Name Field */}
                                <div className="form-row">
                                    <div className="name">Full Name</div>
                                    <div className="value">
                                        <input
                                            className="input--style-6"
                                            type="text"
                                            name="fullname"
                                            value={fullname}
                                            onChange={(e) => setFullName(e.target.value)}
                                            placeholder="Enter your full name"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Email Field */}
                                <div className="form-row">
                                    <div className="name">Email Address</div>
                                    <div className="value">
                                        <input
                                            className="input--style-6"
                                            type="email"
                                            name="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="example@email.com"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Contact Number Field */}
                                <div className="form-row">
                                    <div className="name">Contact Number</div>
                                    <div className="value">
                                        <input
                                            className="input--style-6"
                                            type="text"
                                            name="contact"
                                            value={contact}
                                            onChange={(e) => setContact(e.target.value)}
                                            placeholder="0321********"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Product Field */}
                                <div className="form-row">
                                    <div className="name">Product</div>
                                    <div className="value">
                                        <input
                                            className="input--style-6"
                                            type="text"
                                            name="product"
                                            value={product}
                                            onChange={(e) => setProduct(e.target.value)}
                                            placeholder="Enter insurance type"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Policy Number Field */}
                                <div className="form-row">
                                    <div className="name">Policy Number</div>
                                    <div className="value">
                                        <input
                                            className="input--style-6"
                                            type="text"
                                            name="policynumber"
                                            value={policynumber}
                                            onChange={(e) => setPolicyNumber(e.target.value)}
                                            placeholder="Enter your policy number"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Claim Number Field */}
                                <div className="form-row">
                                    <div className="name">Claim Number</div>
                                    <div className="value">
                                        <input
                                            className="input--style-6"
                                            type="text"
                                            name="claimnumber"
                                            value={claimnumber}
                                            onChange={(e) => setClaimNumber(e.target.value)}
                                            placeholder="Enter your claim number"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Claim Amount Field */}
                                <div className="form-row">
                                    <div className="name">Claim Amount</div>
                                    <div className="value">
                                        <input
                                            className="input--style-6"
                                            type="number"
                                            name="claimamount"
                                            value={claimamount}
                                            onChange={(e) => setClaimAmount(e.target.value)}
                                            placeholder="Enter estimated claim amount in PKR"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Incident Date Field */}
                                <div className="form-row">
                                    <div className="name">Incident Date</div>
                                    <div className="value">
                                        <input
                                            className="input--style-6"
                                            type="date"
                                            name="incidentdate"
                                            value={incidentdate}
                                            onChange={(e) => setIncidentDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Incident Details Field */}
                                <div className="form-row">
                                    <div className="name">Incident Details</div>
                                    <div className="value">
                                        <textarea
                                            className="textarea--style-6"
                                            name="incidentdetails"
                                            value={incidentdetails}
                                            onChange={(e) => setIncidentDetails(e.target.value)}
                                            placeholder="Please describe the incident details"
                                            required
                                        ></textarea>
                                    </div>
                                </div>

                                {/* File Upload Field */}
                              {/* File Upload Field */}
<div className="form-row">
    <div className="name">Attach Documents</div>
    <div className="value">
        {/* File input for multiple files */}
        <input
            className="input-file"
            type="file"
            name="documents"
            onChange={handleFileChange}
            multiple
            required
            id="file-upload"
            style={{ display: 'none' }} // Hide the default file input
        />
        <label className="label--file" htmlFor="file-upload">
            <button 
                type="button" 
                
                onClick={() => document.getElementById('file-upload').click()}>
                Choose Files
            </button>
        </label>
        <span className="input-file__info">Upload up to 7 documents (Max size 50 MB)</span>
    </div>
</div>

                                {/* Submit Button */}
                                <div className="card-footer">
                                    <button className="btn btn-danger" type="submit">SUBMIT</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
